export default {
  ZH_HK: {
    type: "題目類型",
    time: "時間限制",
    second: "秒",
    delete: "刪除",
    copy: "複製",
    exit: "退出",
    save: "保存",
    done: "完成",
    template: "模板選擇",
    reading: "閱讀理解",
    playGame: "試玩遊戲",
    Modifying: "正在修改並保存數據..."
  },
  zh_cn: {
    type: "题目类型",
    time: "时间限制",
    second: "秒",
    delete: "删除",
    copy: "复制",
    exit: "退出",
    save: "保存",
    done: "完成",
    template: "模板选择",
    reading: "阅读理解",
    playGame: "试玩游戏",
    Modifying: "正在修改并保存数据..."
  },

  EN: {
    type: "Question Type",
    time: "Time Limit",
    second: "s",
    delete: "Delete",
    copy: "Copy",
    exit: "Exit",
    save: "Save",
    done: "Done",
    template: "Select Template",
    reading: "Reading Comprehension",
    playGame: "Play Game",
    Modifying: "Modifying and saving data..."
  },
  es: {
    type: "Tipo de Pregunta",
    time: "Límite de tiempo",
    second: "s",
    delete: "Eliminar",
    copy: "Copiar",
    exit: "Salir",
    save: "Guardar",
    done: "Hecho",
    template: "Seleccionar plantilla",
    reading: "Comprensión lectora",
    playGame: "Jugar juego",
    Modifying: "Se están modificando y guardando los datos..."
  }
};
